import { Flex } from '@shared/components';

import { useStandardTemplateData } from '../../hooks';

import QuestionnaireReportStandardSection from './questionnaire-report-standard-section';

export default function QuestionnaireReportStandardTemplate() {
  const { sections, loading } = useStandardTemplateData();

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      {sections.map((section) => (
        <QuestionnaireReportStandardSection key={section.key} section={section} loading={loading} />
      ))}
    </Flex>
  );
}
